var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBtnSmallOff = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 32,
    viewBox: "0 0 80 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3137 0C9.19199 0 7.15715 0.842863 5.65685 2.34317L2.34312 5.65694C0.842843 7.15723 0 9.19205 0 11.3138V24C0 28.4183 3.58172 32 8 32H68.6863C70.808 32 72.8429 31.1571 74.3431 29.6568L77.6569 26.3431C79.1572 24.8428 80 22.808 80 20.6862V8C80 3.58172 76.4183 0 72 0H11.3137Z",
    fill: "var(--step-btn-bg)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 28L46.3431 27.9998C47.404 27.9998 48.4214 27.5783 49.1716 26.8282L50.8284 25.1713C51.5786 24.4212 52.596 23.9998 53.6569 23.9998L71 24C73.2091 24 75 25.7909 75 28V29L74.3431 29.6568C72.8429 31.1571 70.808 32 68.6863 32H8C3.58172 32 0 28.4183 0 24V22C0 25.3137 2.68629 28 6 28Z",
    fill: "var(--step-btn-bar)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBtnSmallOff);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/btn_small_off.e8004275a51f58c16e2e003baa1a9d8c.svg";